import { localizedBlockText } from "./localized-content";
export type StorefrontBlockContext = {
  attrs: Record<string, unknown>;
  data: unknown;
  locale: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function blockHeadingLevel(blockIndex: unknown): 1 | 2 {
  return blockIndex === 0 ? 1 : 2;
}

export function childHeadingLevel(parent: 1 | 2 | 3): 2 | 3 | 4 {
  return parent === 1 ? 2 : parent === 2 ? 3 : 4;
}

/**
 * Resolve the effective props for a CMS block.
 *
 * The CMS does not pass props to registered block components. Author configured
 * attributes and server-resolved blockData are exposed through useBlock(). The
 * server response is authoritative for catalog data and generated shop URLs;
 * the live CMS locale is authoritative over both stored and server values.
 */
export function resolveStorefrontBlockProps<T extends object>(
  defaults: T,
  context: StorefrontBlockContext,
): T & Record<string, unknown> & { locale: string } {
  const serverData = isRecord(context.data)
    ? context.data
    : context.data === undefined
      ? {}
      : { data: context.data };

  const resolved = {
    ...defaults,
    ...context.attrs,
    ...serverData,
    locale: context.locale,
  } as T & Record<string, unknown> & { locale: string };
  if ("emptyMessage" in resolved) (resolved as Record<string, unknown>).emptyMessage = localizedBlockText(resolved.emptyMessage, context.locale);
  return resolved;
}
